import { useAtomValue } from 'jotai';
import { userInfoAtom } from '../data/atoms/utilsAtoms';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { userRoleTypes } from '../utils/userRoleTypes';

import { ContentView } from '../Pages/VideoPlayer/utils/queryParamsKeys';
import useAuthentication from './useAuthentication';
import { useVerifySubscription } from './useVerifySubscription';
import { useVideoDetailsFromParams } from '../Pages/VideoPlayer/hooks/useVideoDetailsFromParams';

export const useAuthorizationForNonSubscribeUser = (isPromo = false) => {
	const userData = useAtomValue(userInfoAtom);
	const navigate = useNavigate();
	const { typeOfContentView } = useVideoDetailsFromParams();

	useAuthentication(userData.role, isPromo);

	const status = useVerifySubscription(isPromo);

	useEffect(() => {
		// Skip all auth/subscription checks for promo users
		if (isPromo) return;

		// Wait for subscription verification and data to load
		if (status === null || !userData.user) {
			return;
		}
		// Wait for subscription data to load
		if (userData.subscriptionId === undefined && userData.user?.isTrialAvailed === undefined) {
			return;
		}
		if (typeOfContentView && typeOfContentView !== ContentView.CLASSES && userData.role === userRoleTypes.USER) {
			if (userData.user) {
				if (!userData.subscriptionId) {
					if (!userData.user?.isTrialAvailed || !status) {
						navigate('/plans');
					}
				}
			}
		}

		if (typeOfContentView && typeOfContentView === ContentView.STUDIO && userData.user && !userData.user?.userType) {
			if (userData.user) {
				if (!userData.subscriptionId) {
					if (!userData.user?.isTrialAvailed) {
						navigate('/plans');
					}
				}
			}
		}
	}, [
		navigate,
		userData.role,
		userData.subscriptionId,
		userData.user,
		userData.user?.isTrialAvailed,
		status,
		typeOfContentView,
		isPromo
	]);
};
